import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.25152 8.3252L5 9.54542L12 16.3252L19 9.53856L17.7485 8.3252L12 13.8985L6.25152 8.3252Z",
		fill: "black",
		fillOpacity: .54
	})
});
export default SvgDropdown;
